/* eslint-disable global-require */

import Vue from 'vue';

export default (function registerLayots() {
  Vue.component('l-default', () => import('@/app/layouts/LayoutDefault'));
  Vue.component('l-mobile', () => import('@/app/layouts/LayoutMobile'));
  Vue.component('l-kiosk', () => import('@/app/layouts/LayoutKiosk'));
  Vue.component('l-legacy', () => import('@/app/layouts/LayoutLegacy'));

  Vue.component('l-header-regular', () => import('@/app/layouts/HeaderRegular'));
  Vue.component('l-header-mobile', () => import('@/app/layouts/HeaderMobile'));
  Vue.component('l-header-kiosk', () => import('@/app/layouts/HeaderKiosk'));

  Vue.component('l-content-simple', () => import('@/app/layouts/ContentSimple'));
  Vue.component('l-content-cart', () => import('@/app/layouts/ContentWithCart'));
  Vue.component('l-content-no-cart', () => import('@/app/layouts/ContentWithoutCart'));
}());



// WEBPACK FOOTER //
// ./src/app/layouts/_register.js